import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";
import store from "../store/";

import VueRouter from "vue-router";
// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
// Pages
const Microservices = () => import("@/pages/Dashboard/Pages/Microservices.vue");
const Clients = () => import("@/pages/Dashboard/Pages/Clients.vue");
const Servers = () => import("@/pages/Dashboard/Pages/Servers.vue");
const ServerOne = () => import("@/pages/Dashboard/Pages/Server.vue");
const ClientOne = () => import("@/pages/Dashboard/Pages/Client.vue");
const User = () => import("@/pages/Dashboard/Pages/UserProfile.vue");
// const Pricing = () => import("@/pages/Dashboard/Pages/Pricing.vue");
const TimeLine = () => import("@/pages/Dashboard/Pages/TimeLinePage.vue");
const RtlSupport = () => import("@/pages/Dashboard/Pages/RtlSupport.vue");
const Login = () => import("@/pages/Dashboard/Pages/Login.vue");
// const Register = () => import("@/pages/Dashboard/Pages/Register.vue");
// const Lock = () => import("@/pages/Dashboard/Pages/Lock.vue");

// Components pages
const Buttons = () => import("@/pages/Dashboard/Components/Buttons.vue");
const GridSystem = () => import("@/pages/Dashboard/Components/GridSystem.vue");
const Panels = () => import("@/pages/Dashboard/Components/Panels.vue");
const SweetAlert = () => import("@/pages/Dashboard/Components/SweetAlert.vue");
const Notifications = () =>
  import("@/pages/Dashboard/Components/Notifications.vue");
const Icons = () => import("@/pages/Dashboard/Components/Icons.vue");
const Typography = () => import("@/pages/Dashboard/Components/Typography.vue");

// Forms pages
const RegularForms = () => import("@/pages/Dashboard/Forms/RegularForms.vue");
const ExtendedForms = () => import("@/pages/Dashboard/Forms/ExtendedForms.vue");
const ValidationForms = () =>
  import("@/pages/Dashboard/Forms/ValidationForms.vue");
const Wizard = () => import("@/pages/Dashboard/Forms/Wizard.vue");

// TableList pages
const RegularTables = () =>
  import("@/pages/Dashboard/Tables/RegularTables.vue");
const ExtendedTables = () =>
  import("@/pages/Dashboard/Tables/ExtendedTables.vue");
const PaginatedTables = () =>
  import("@/pages/Dashboard/Tables/PaginatedTables.vue");

// Maps pages
const GoogleMaps = () => import("@/pages/Dashboard/Maps/GoogleMaps.vue");
const FullScreenMap = () => import("@/pages/Dashboard/Maps/FullScreenMap.vue");
const VectorMaps = () => import("@/pages/Dashboard/Maps/VectorMaps.vue");

// Calendar
// const Calendar = () => import("@/pages/Dashboard/Calendar.vue");
// Charts
// const Charts = () => import("@/pages/Dashboard/Charts.vue");
// import Widgets from "@/pages/Dashboard/Widgets.vue";

let componentsMenu = {
  path: "/components",
  component: DashboardLayout,
  redirect: "/components/buttons",
  name: "Components",
  children: [
    {
      path: "buttons",
      name: "Buttons",
      components: { default: Buttons }
    },
    {
      path: "grid-system",
      name: "Grid System",
      components: { default: GridSystem }
    },
    {
      path: "panels",
      name: "Panels",
      components: { default: Panels }
    },
    {
      path: "sweet-alert",
      name: "Sweet Alert",
      components: { default: SweetAlert }
    },
    {
      path: "notifications",
      name: "Notifications",
      components: { default: Notifications }
    },
    {
      path: "icons",
      name: "Icons",
      components: { default: Icons }
    },
    {
      path: "typography",
      name: "Typography",
      components: { default: Typography }
    }
  ]
};
let formsMenu = {
  path: "/forms",
  component: DashboardLayout,
  redirect: "/forms/regular",
  name: "Forms",
  children: [
    {
      path: "regular",
      name: "Regular Forms",
      components: { default: RegularForms }
    },
    {
      path: "extended",
      name: "Extended Forms",
      components: { default: ExtendedForms }
    },
    {
      path: "validation",
      name: "Validation Forms",
      components: { default: ValidationForms }
    },
    {
      path: "wizard",
      name: "Wizard",
      components: { default: Wizard }
    }
  ]
};

let tablesMenu = {
  path: "/table-list",
  component: DashboardLayout,
  redirect: "/table-list/regular",
  name: "Tables",
  children: [
    {
      path: "regular",
      name: "Regular Tables",
      components: { default: RegularTables }
    },
    {
      path: "extended",
      name: "Extended Tables",
      components: { default: ExtendedTables }
    },
    {
      path: "paginated",
      name: "Pagianted Tables",
      components: { default: PaginatedTables }
    }
  ]
};

let mapsMenu = {
  path: "/maps",
  component: DashboardLayout,
  name: "Maps",
  redirect: "/maps/google",
  children: [
    {
      path: "google",
      name: "Google Maps",
      components: { default: GoogleMaps }
    },
    {
      path: "full-screen",
      name: "Full Screen Map",
      meta: {
        hideContent: true,
        hideFooter: true,
        navbarAbsolute: true
      },
      components: { default: FullScreenMap }
    },
    {
      path: "vector-map",
      name: "Vector Map",
      components: { default: VectorMaps }
    }
  ]
};

let pagesMenu = {
  path: "/pages",
  component: DashboardLayout,
  name: "Pages",
  redirect: "/pages/user",
  children: [
    {
      path: "user",
      name: "User Page",
      components: { default: User }
    },
    {
      path: "timeline",
      name: "Timeline Page",
      components: { default: TimeLine }
    },
    {
      path: "rtl",
      name: "وحة القيادة",
      meta: {
        rtlActive: true
      },
      components: { default: RtlSupport }
    }
  ]
};

let authPages = {
  path: "/",
  component: AuthLayout,
  name: "Authentication",
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        guestOnly: true
      }
    }
    // {
    //   path: "/register",
    //   name: "Register",
    //   component: Register
    // },
    // {
    //   path: "/pricing",
    //   name: "Pricing",
    //   component: Pricing
    // },
    // {
    //   path: "/lock",
    //   name: "Lock",
    //   component: Lock
    // }
  ]
};

const routes = [
  {
    path: "/",
    redirect: "/microservices",
    name: "Home",
    meta: {
      requireAuth: true
    }
  },
  componentsMenu,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  authPages,
  {
    path: "/",
    component: DashboardLayout,
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        components: { default: Dashboard },
        meta: {
          requireAuth: true
        }
      },
      {
        path: "microservices",
        name: "Microservices",
        components: { default: Microservices },
        meta: {
          requireAuth: true,
          showBottom: true,
          showAdd: false
        }
      },
      {
        path: "servers",
        name: "Servers",
        components: { default: Servers },
        meta: {
          requireAuth: true,
          showBottom: true
        }
      },
      {
        path: "server",
        name: "Server",
        components: { default: ServerOne },
        meta: {
          requireAuth: true,
          showBottom: false,
          showAdd: false
        }
      },
      {
        path: "client",
        name: "Client",
        components: { default: ClientOne },
        meta: {
          requireAuth: true,
          showBottom: false,
          showAdd: false
        }
      },
      {
        path: "clients",
        name: "Clients",
        components: { default: Clients },
        meta: {
          requireAuth: true,
          showBottom: true,
          showAdd: true
        }
      }
    ]
  }
];
// configure router
let router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
  // debugger;
  if (to.matched.some(record => record.meta.showBottom)) {
    store.commit("toogleBottom", true);
  } else {
    store.commit("toogleBottom", false);
  }
  if (to.matched.some(record => record.meta.showAdd)) {
    store.commit("toggleAdd", true);
  } else {
    store.commit("toggleAdd", false);
  }

  if (to.matched.some(record => record.meta.requireAuth)) {
    if (!store.getters["users/isLogged"]) {
      next({
        path: "/login",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    if (store.getters["users/isLogged"]) {
      next({
        path: "/",
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      next();
    }
  } else {
    next();
  }
});
export default router;
